import React from 'react';
import './Mixedplastic.css';
import bucket from '../../../imgs/buckets.webp';

const Mixedplastic = () => {
    return (
        <div className="Material-container">
            <div className='Materialsl'>
                <h2 className="Material-title">Mixed Two-Color Plastic Buckets Injection Molding</h2>
                <p className="Material-date">Nov. 4, 2022</p>
                <div className="advantpl">
                    <img src={bucket} alt="72 Cavity PET Preforms Machine" className="advantpla-image" />
                </div>
                <p className="Material-text">Disha Mixed Double Color Injection Molding
                     Machine widely used in daily necessities, hotel toiletries, handicraft decorations,
                     children’s toys, medical instruments, and other industries.</p>
                <p className="Material-date">Our customers are satisfied with our
                     multi-material injection molding machines.</p>
            </div>
        </div>
    );
};
export default Mixedplastic;
